import { Model } from './model';
import type { Task } from './task';

export enum TaskRequirementStatus {
  ANSWERED = 'answered',
  COMPLETED = 'completed',
  OPEN = 'open',
  RESOLVED = 'resolved',
  DISMISSED = 'dismissed',
  SKIPPED = 'skipped',
}

export interface TaskRequirementInputSpec {
  accept?: string[];
  entity_type?: string;
}

export interface TaskRequirementOption {
  key: string;
  label: string;
  description?: string;
}

export class TaskRequirement extends Model {
  object = 'task_hitl';

  id: string;
  allow_custom: boolean;
  allow_dismiss: boolean;
  allow_skip: boolean;
  context: string;
  hitl_status: TaskRequirementStatus;
  input_spec: TaskRequirementInputSpec | null;
  input_type: string;
  options: TaskRequirementOption[] | null;
  organization_id: string;
  prompt: string;
  resolution: any | null;
  resolution_source: string | null;
  resolved_by: string | null;
  resolved_by_user_id: string | null;
  task_id: string;

  get isAnswered(): boolean {
    return this.hitl_status === TaskRequirementStatus.ANSWERED;
  }

  get isCompleted(): boolean {
    return this.hitl_status === TaskRequirementStatus.COMPLETED;
  }

  get isOpen(): boolean {
    return this.hitl_status === TaskRequirementStatus.OPEN;
  }

  get isDismissed(): boolean {
    return this.hitl_status === TaskRequirementStatus.DISMISSED;
  }

  get isResolved(): boolean {
    return [
      TaskRequirementStatus.COMPLETED,
      TaskRequirementStatus.DISMISSED,
      TaskRequirementStatus.SKIPPED,
    ].includes(this.hitl_status);
  }

  get isSkipped(): boolean {
    return this.hitl_status === TaskRequirementStatus.SKIPPED;
  }

  get isFileInput(): boolean {
    return this.input_type === 'file';
  }

  get acceptedFileTypes(): string[] {
    return this.input_spec?.accept ?? [];
  }

  get isDisabled(): boolean {
    return this.isCompleted || this.isDismissed;
  }

  isEditable(): boolean {
    return !this.isDisabled && !!this.resolution?.value;
  }
}
